<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-key"></i></div>
      <div>
        Permissions
        <div class="page-title-subheading">Droits attribuables aux rôles</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
 
      <div class="row">
        <div class="main-card mb-3 card">
          <div class="card-body">
            <div class="d-flex justify-content-between mb-5">
<div class="me-2">
                        <button type="button" class="btn btn-danger btn-sm" (click)="add(contentAdd)">
        <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle permission
      </button>
                    </div>
                                  <div class=" " >
                  <button  (click)="edit(contentEdit)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                    Editer</button>
                  <button  (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                       Supprimer</button>
                       
              </div>

              <div class="form-group ms-auto">
                  <label for=""> <strong>Rechercher:</strong> </label>
                  <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
              </div>
          </div>
            <p>{{data!.length}} élément(s)</p>
            <div class="table-responsive">
            <table class="table" >
                <thead class="">
                    <tr>
                        <th style="width: 10px;">#</th>
                        <th>Libellé</th>
                    </tr>
                </thead>
                <tbody>
                    <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'permissions'  | paginate: {
                    id:'ngxP1',
                    itemsPerPage: pg.pageSize,
                    currentPage: pg.p,
                    totalItems: pg.total } ">
                        <td>
                            <div class="form-check mb-2">
                                <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                            
                            </div>
                        </td>
                        <td>{{d.name}}</td>
                       
                    </tr>
                
                </tbody>
            </table>
            </div>
              <pagination-controls 
            id="ngxP1"
            (pageChange)="getPage($event)"
          [maxSize]="9"
          [directionLinks]="true"
          [autoHide]="true"
          [responsive]="true"
          [previousLabel]="'Précédent'"
          [nextLabel]="'Suivant'"
          [screenReaderPaginationLabel]="'Pagination'"
          [screenReaderPageLabel]="'page'"
          [screenReaderCurrentLabel]="'Vous êtes sur la page'">
         </pagination-controls>
          </div>
          </div>
        </div>
  
  
  
        <ng-template  #contentAdd let-c="close" let-d="dismiss">
          <form #addForm="ngForm" (ngSubmit)="create(addForm.value)">
            <div class="modal-header">
              <h6 class="modal-title" id="modal-basic-title">Créer une permission</h6>
              <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
            </div>
            <div class="modal-body" >
                <div class="row mb-3">
                    <div class=" form-goup col-12 mb-3">
                        <label for="">Fonctionnalité du système <span class="text-danger ml-2">(*)</span></label>
                        <ng-select name="feature_id" ngModel required>
                          <ng-option *ngFor="let f of features" [value]="f.id">{{f.name}} | {{f.space}}</ng-option>
                        </ng-select>
                    </div> 
                    <div class=" form-goup col-12 mb-3">
                      <label for="">Action permises <span class="text-danger ml-2">(*)</span></label>
                      <ng-select name="actions" [(ngModel)]="actions2" [multiple]="true" required>
                        <ng-option *ngFor="let a of actions" [value]="a">{{a}}</ng-option>
                      </ng-select>
                  </div> 
                </div>
               
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
            </div>
        </form>
          </ng-template> 

          <ng-template  #contentEdit let-c="close" let-d="dismiss">
            <form #addForm="ngForm" (ngSubmit)="update(addForm.value)">
              <div class="modal-header">
                <h6 class="modal-title" id="modal-basic-title">Modifiier une permission</h6>
                <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
              </div>
              <div class="modal-body" >
                <div class="row mb-3">
                  <div class=" form-goup col-12 mb-3">
                      <label for="">Fonctionnalité du système <span class="text-danger ml-2">(*)</span></label>
                      <ng-select name="feature_id" [(ngModel)]="selected_data.feature_id">
                        <ng-option *ngFor="let f of features" [value]="f.id">{{f.name}} | {{f.space}}</ng-option>
                      </ng-select>
                  </div> 
                  <div class=" form-goup col-12 mb-3">
                    <label for="">Action <span class="text-danger ml-2">(*)</span></label>
                    <ng-select name="action" [(ngModel)]="selected_data.action">
                      <ng-option *ngFor="let a of actions" [value]="a">{{a}}</ng-option>
                    </ng-select>
                </div> 
              </div>
             
                 
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
              </div>
          </form>
          </ng-template> 

          <ng-template  #contentShow let-c="close" let-d="dismiss">
            <div class="modal-header bg-primary text-white text-center">
                <h4 class="modal-title">Détails</h4>
                <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
              </div>

            <div class="modal-body">
            

                <dl class="mb-3">
                    <dt>Nom</dt>
                    <dd>{{selected_data.name}}</dd>
                </dl>

             
            </div>
          </ng-template> 